class TileInCartController {}

const tileInCartComponentDefinition = {
    bindings: {
        product: '<',
        classModifier: '@?',
    },
    controller: TileInCartController,
    template: require('./tile-in-cart.component.html').trim(),
};

module.exports = {
    TileInCartController,
    tileInCartComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/tile-in-cart.component.js